import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PersistConfig, persistReducer } from 'redux-persist';

import { AppStateEnum } from '../../../main/types/app-state.types.ts';
import { getReduxStorageUtil } from '../../../main/utils/storage/redux-storage.util.ts';

import { CharacterBubbleAnimation } from '../../constants/character-bubble-animations.ts';

import { APP_STATE_SLICE_NAME, AppStateSliceState } from './app-state.slice.types.ts';
import { updateAppStateThunkExtraReducers } from './thunks/update-app-state.thunk.ts';

export const APP_STATE_SLICE_INITIAL_STATE: AppStateSliceState = {
  state: AppStateEnum.ReadyToStart,
  isBlockingAnimation: false,
  isAbortingStep: false,
  isSpeaking: false,
  currentUpdateTimeoutId: null,
  currentCharacterBubbleAnimation: null,
};

const persistKeys: (keyof AppStateSliceState)[] = [];

const persistConfig = {
  key: APP_STATE_SLICE_NAME,
  storage: getReduxStorageUtil(),
  whitelist: persistKeys,
} as PersistConfig<AppStateSliceState>;

const appStateSlice = createSlice({
  name: APP_STATE_SLICE_NAME,
  initialState: APP_STATE_SLICE_INITIAL_STATE,
  reducers: {
    resetAppStateSlice: () => {
      return APP_STATE_SLICE_INITIAL_STATE;
    },
    setIsBlockingAnimation: (state, action: PayloadAction<boolean>) => {
      state.isBlockingAnimation = action.payload;
    },
    setIsAbortingStep: (state, action: PayloadAction<boolean>) => {
      state.isAbortingStep = action.payload;
    },
    setIsSpeaking: (state, action: PayloadAction<boolean>) => {
      state.isSpeaking = action.payload;
    },
    setCurrentUpdateTimeoutId: (state, action: PayloadAction<NodeJS.Timeout | null>) => {
      state.currentUpdateTimeoutId = action.payload;
    },
    setCurrentCharacterBubbleAnimation: (state, action: PayloadAction<CharacterBubbleAnimation>) => {
      state.currentCharacterBubbleAnimation = action.payload;
    },
    resetCharacterBubbleAnimation: (state) => {
      state.currentCharacterBubbleAnimation = null;
    },
  },
  extraReducers: (builder) => {
    updateAppStateThunkExtraReducers(builder);
  },
});

export const {
  resetAppStateSlice,
  setIsBlockingAnimation,
  setIsAbortingStep,
  setIsSpeaking,
  setCurrentUpdateTimeoutId,
  setCurrentCharacterBubbleAnimation,
  resetCharacterBubbleAnimation,
} = appStateSlice.actions;

export const AppStateSlice = persistReducer(persistConfig, appStateSlice.reducer);
